import { DefaultNodeModel, Toolkit } from "storm-react-diagrams";
import { CustomPortModel } from "designer/widgets/CustomLinkFactory";

export class CustomNodeModel extends DefaultNodeModel {
  constructor(name: string = "Untitled", color: string = "rgb(0,192,255)") {
    super(name, color);
    this.type = "custom";
  }
  addInPort(label: string): CustomPortModel {
    return this.addPort(new CustomPortModel(true, Toolkit.UID(), label));
  }

  addOutPort(label: string): CustomPortModel {
    return this.addPort(new CustomPortModel(false, Toolkit.UID(), label));
  }
}



// WEBPACK FOOTER //
// ./src/designer/widgets/CustomNodeModel.ts